enum MfaType {
  GOOGLE_AUTH = 'google_auth',
  EMAIL = 'email',
}

export default MfaType;
